import { isIOS, isWeb } from "@memorang/helpers/platform";
import useBreakpoints from "./useBreakpoints";

export const useDevice = () => {
	const { smDown, smUp, mdDown, lgUp, xxsDown } = useBreakpoints();

	const isSmallScreen = xxsDown;
	const isMobile = smDown;
	const isMediumWindowSize = smUp && mdDown;
	const isLargeWindowSize = lgUp;
	const isIpad = isIOS && smUp;

	const isDesktopWeb = isWeb && !isMobile;
	const isMobileWeb = isWeb && isMobile;

	return {
		isSmallScreen,
		isMobile,
		isMediumWindowSize,
		isLargeWindowSize,
		isIpad,
		isDesktopWeb,
		isMobileWeb,
	};
};
